import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Theme.vue"),
    children: [
      {
        path: "/",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "Home" */ "../views/Home.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-tachometer"
          }],
        },
      },
      {
        path: "/leads",
        name: "Leads",
        component: () =>
          import(/* webpackChunkName: "Leads" */ "../views/Leads.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-user-plus"
          }],
        },
      },
      {
        path: "/lead",
        name: "Lead",
        component: () =>
          import(/* webpackChunkName: "Lead" */ "../views/Lead.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-user"
          }],
        },
      },
      {
        path: "/opportunities",
        name: "Opportunities",
        component: () =>
          import(/* webpackChunkName: "Opportunities" */ "../views/Opportunities.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-bulb" // ícone usado no modal
          }],
        },
      },
      {
        path: "/conversations",
        name: "Conversations",
        component: () =>
          import(/* webpackChunkName: "Conversations" */ "../components/leads/Conversations.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-message-rounded-dots" // ícone usado no modal
          }],
        },
      },
      
      {
        path: "/users",
        name: "Users",
        component: () =>
          import(/* webpackChunkName: "Users" */ "../views/Users.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-group"
          }],
        },
      },
      {
        path: "/user",
        name: "User",
        component: () =>
          import(/* webpackChunkName: "User" */ "../views/User.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-group"
          }],
        },
      },
      {
        path: "/channels",
        name: "Channels",
        component: () =>
          import(/* webpackChunkName: "Channels" */ "../views/Channels.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-message-square-detail"
          }],
        },
      },
      
      {
        path: "/channel",
        name: "Channel",
        component: () =>
          import(/* webpackChunkName: "Channel" */ "../views/Channel.vue"),
        meta: {
          breadcrumb: [{}],
        },
      },
      {
        path: "/campaigns",
        name: "Campaigns",
        component: () =>
          import(/* webpackChunkName: "Campaigns" */ "../views/Campaigns.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-rocket"
          }],
        },
      },
      {
        path: "/campaign",
        name: "Campaign",
        component: () =>
          import(/* webpackChunkName: "Campaign" */ "../views/Campaign.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-rocket"
          }],
        },
      },


         // NOVAS ROTAS

      // ROTA REPORTS
      {
        path: "/reports",
        name: "Reports",
        component: () =>
          import(/* webpackChunkName: "Reports" */ "../views/Reports.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-bar-chart-alt"
          }],
        },
      },
        // ROTA REPORTS


 // ROTA Settings
{
  path: "/settings",
  component: () => 
    import(/* webpackChunkName: "Settings" */ "../views/Settings.vue"),
  meta: {
    breadcrumb: [{
      icon: "bx bx-cog"
    }],
  },
  children: [
    {
      path: "",
      redirect: "custom-fields"  // Remove the name: "Settings" from here
    },
    {
      path: "general",
      name: "SettingsGeneral",
      component: () => import(/* webpackChunkName: "SettingsGeneral" */ "../views/settings/General.vue"),
      meta: {
        breadcrumb: [{ icon: "bx bx-cog" }],
      }
    },
    {
      path: "custom-fields",
      name: "CustomFields",
      component: () => import(/* webpackChunkName: "CustomFields" */ "../views/settings/CustomFields.vue"),
      meta: {
        breadcrumb: [{ icon: "bx bx-user-circle" }],
      }
    },
    {
      path: "integrations",
      name: "Integrations",
      component: () => import(/* webpackChunkName: "Integrations" */ "../views/settings/Integrations.vue"),
      meta: {
        breadcrumb: [{ icon: "bx bx-extension" }],
      }
    }
  ]
},

   // ROTA Notifications
{
  path: "/notifications-center",
  name: "NotificationsCenter",
  component: () =>
    import(/* webpackChunkName: "Notifications" */ "../views/NotificationsPage.vue"),
  meta: {
    breadcrumb: [{
      icon: "bx bx-bell"
    }],
  },
},
// ROTA Notifications


       // NOVAS ROTAS



      {
        path: "/reports/tickets",
        name: "ReportsTickets",
        component: () =>
          import(/* webpackChunkName: "ReportsTickets" */ "../components/reports/ReportsTickets.vue"),
        meta: {
          breadcrumb: [{
            icon: "fas fa-comments"
          }],
        },
      },
      {
        path: "/reports/webhooks",
        name: "ReportsWebhooks",
        component: () =>
          import(/* webpackChunkName: "ReportsWebhooks" */ "../components/reports/ReportsWebhooks.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bxs-error-circle"
          }],
        },
      },
      {
        path: "/reports/operators",
        name: "ReportsOperatorsLeads",
        component: () =>
          import(/* webpackChunkName: "ReportsOperatorsLeads" */ "../components/reports/ReportsOperatorsLeads.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-support"
          }],
        },
      },
      {
        path: "/reports/sms",
        name: "ReportsSms",
        component: () =>
          import(/* webpackChunkName: "ReportsSms" */ "../components/reports/ReportsSms.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bxs-message"
          }],
        },
      },
      {
        path: "/reports/voip",
        name: "ReportsVoip",
        component: () =>
          import(/* webpackChunkName: "ReportsVoip" */ "../components/reports/ReportsVoip.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bxs-phone-call"
          }],
        },
      },
      {
        path: "/reports/email",
        name: "ReportsEmail",
        component: () =>
          import(/* webpackChunkName: "ReportsEmail" */ "../components/reports/ReportsEmail.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bxs-envelope-open"
          }],
        },
      },
      {
        path: "/reports/hsm",
        name: "ReportsHsm",
        component: () =>
          import(/* webpackChunkName: "ReportsHsm" */ "../components/reports/ReportsHsm.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-copy-alt"
          }],
        },
      },
      {
        path: "/reports/nps",
        name: "ReportsNps",
        component: () =>
          import(/* webpackChunkName: "ReportsNps" */ "../components/reports/ReportsNps.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bxs-star"
          }],
        },
      },
      {
        path: "/reports/campaign",
        name: "ReportsCampaigns",
        component: () =>
          import(/* webpackChunkName: "ReportsCampaigns" */ "../components/reports/ReportsCampaigns.vue"),
        meta: {
          breadcrumb: [{
            icon: "fas fa-thumbs-up"
          }],
        },
      },
      {
        path: "/reports/campaign-tracking",
        name: "ReportsCampaignTracking",
        component: () =>
          import(/* webpackChunkName: "ReportsCampaignTracking" */ "../components/reports/ReportsCampaignTracking.vue"),
        meta: {
          breadcrumb: [{
            icon: "fas fa-chart-area"
          }],
        },
      },
      {
        path: "/reports/chatbot",
        name: "ReportsChatbot",
        component: () =>
          import(/* webpackChunkName: "ReportsChatbot" */ "../components/reports/ReportsChatbot.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-bot"
          }],
        },
      },
      {
        path: "/reports/opportunities",
        name: "ReportsOpportunities",
        component: () =>
          import(/* webpackChunkName: "ReportsOpportunities" */ "../components/reports/ReportsOpportunities.vue"),
        meta: {
          breadcrumb: [{
            icon: "fi fi-rr-square-kanban"
          }],
        },
      },
      /*{
        path: "/tasks",
        name: "Tasks",
        component: () =>
          import(/!* webpackChunkName: "Tasks" *!/ "../views/Tasks.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-task"
          }],
        },
      },*/
      {
        path: "/activities",
        name: "Activities",
        component: () =>
          import(/* webpackChunkName: "Tasks" */ "../views/Activities.vue"),
        meta: {
          breadcrumb: [{
            icon: "bx bx-task"
          }],
        },
      },
      {
        path: "/chat",
        name: "Chat",
        component: () =>
          import(/* webpackChunkName: "Chat" */ "../views/Chat.vue"),
        meta: {
          breadcrumb: [{
            name: "Chat",
            icon: "bx bx-chat"
          }],
        },
      },
      {
        path: "/kanban",
        name: "Kanban",
        component: () =>
          import(/* webpackChunkName: "Kanban" */ "../views/Kanban.vue"),
        meta: {
          breadcrumb: [{
            name: "Kanban",
            icon: "bx bx-tachometer"
          }],
        },
      },
      {
        path: "/tickets",
        name: "KanbanTickets",
        component: () =>
          import(/* webpackChunkName: "Kanban" */ "../views/KanbanTickets.vue"),
        meta: {
          breadcrumb: [{
            name: "KanbanTickets",
            icon: "bx bx-tachometer"
          }],
        },
      },
      {
        path: "/gallery",
        name: "Gallery",
        component: () =>
          import(/* webpackChunkName: "Gallery" */ "../views/Gallery.vue"),
        meta: {
          breadcrumb: [{
            name: "Gallery",
            icon: "bx bx-tachometer"
          }],
        },
      },
      {
        path: "/vue-editor",
        name: "VueEditor2",
        component: () =>
          import(/* webpackChunkName: "Gallery" */ "../views/VueEditor2.vue"),
        meta: {
          breadcrumb: [{
            name: "VueEditor2",
            icon: "bx bx-tachometer "
          }],
        },
      },
      {
        path: "/products",
        name: "Products",
        component: () =>
          import(/* webpackChunkName: "Products" */ "../views/Products.vue"),
        meta: {
          breadcrumb: [{
            name: "Products",
            icon: "bx bx-tachometer"
          }],
        },
      },
      {
  path: "/reports/campaign-performance",
  name: "ReportsCampaignPerformance",
  component: () =>
    import(/* webpackChunkName: "ReportsCampaignPerformance" */ "../views/ReportsCampaignPerformance.vue"),
  meta: {
    breadcrumb: [{
      icon: "bx bx-bar-chart-square"
    }],
  },
},

    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "../views/Register.vue")
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: () =>
      import(/* webpackChunkName: "Confirmation" */ "../views/Confirmation.vue")
  },
  {
    path: "/recovery/:token",
    name: "RecoveryToken",
    component: () =>
      import(/* webpackChunkName: "RecoveryToken" */ "../views/Recovery.vue")
  },
  {
    path: "/recovery",
    name: "Recovery",
    component: () =>
      import(/* webpackChunkName: "Recovery" */ "../views/Recovery.vue")
  },
  {
    path: "/confirm-email/:token",
    name: "ConfirmEmailToken",
    component: () =>
      import(/* webpackChunkName: "ConfirmEmailToken" */ "../views/ConfirmEmail.vue")
  },
  {
    path: "/confirm-email/",
    name: "ConfirmEmail",
    component: () =>
      import(/* webpackChunkName: "ConfirmEmail" */ "../views/ConfirmEmail.vue")
  },
  {
    path: "/confirm-whatsapp/:token",
    name: "ConfirmWhatsAppToken",
    component: () =>
      import(/* webpackChunkName: "ConfirmEmailToken" */ "../views/ConfirmWhatsApp.vue")
  },
  {
    path: "/logout",
    name: "Logout",
    component: () =>
      import(/* webpackChunkName: "Logout" */ "../views/Logout.vue")
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue'),
  },
];
